import React, { Component } from 'react'
import AppleLogin from 'react-apple-login'
import Icon from './Icons'

class AppleLoginErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { failed: false }
  }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  render() {
    if (this.state.failed) {
      return <SignInWithAppleBtnRender appleLogin={null} text={this.props.text} blocked />
    }
    return this.props.children
  }
}

function SignInWithAppleBtnRender(props) {
  const { appleLogin, text, blocked } = props
  let buttonText = 'Sign in with Apple'
  if (text === 'signup_with') {
    buttonText = 'Sign up with Apple'
  } else if (text === 'continue_with') {
    buttonText = 'Continue with Apple'
  }

  return (
    <button
      onClick={blocked ? undefined : appleLogin}
      className={`signin-signInWithAppleBtn${blocked ? ' signin-signInWithAppleBtn--blocked' : ''}`}
      disabled={blocked}
    >
      <div className='signin-signInWithAppleBtn-centerContent'>
        {!blocked && (
          <div className='signin-signInWithAppleBtn-centerContent-icon'>
            <Icon name='appleSignInLogo' />
          </div>
        )}
        <div className='signin-signInWithAppleBtn-centerContent-label'>
          {blocked ? 'Apple Sign In blocked on this network' : buttonText}
        </div>
      </div>
    </button>
  )
}

function SignInWithAppleButton(props) {
  const { callback, redirectPath, text } = props
  return (
    <AppleLoginErrorBoundary text={text}>
      <AppleLogin
        clientId={process.env.REACT_APP_SIGN_IN_WITH_APPLE_CLIENT_ID}
        redirectURI={`${window.location.origin}${redirectPath}`}
        usePopup
        callback={(data) => callback(data)}
        scope='email name'
        responseType='query'
        render={(renderProps) => (<SignInWithAppleBtnRender appleLogin={renderProps.onClick} text={text} />)}
      />
    </AppleLoginErrorBoundary>
  )
}

export default SignInWithAppleButton
